<template>
    <LayoutBlock
    :tutorial_dialog="tutorial_dialog"
    ref="layoutBlock"
    v-on:closeDialog="handleCloseDialog"
    >
    <div class="d-flex flex-column" v-if="measures">
        <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="6">
                    <NumericField
                        label="fattore di copertura K"
                        v-model="measures.k"
                        :readonly="preview"
                    />
                </v-col>
                <v-col cols="6">
                    <v-checkbox dense outlined label="verifica conformità"  v-if="!preview" v-model="measures.useTolerance"></v-checkbox>
                </v-col>
                <v-col cols="12" class="my-2">
                    <span v-if="measures.useTolerance" class="my-2">
                        tolleranza: <i>{{computeToleranceType.type}}, {{computeToleranceType.value}}</i>
                    </span>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end py-2" v-if="!preview">
                    <v-btn color="primary" @click="autoFillPressureGauge(measures)">Riempimento automatico</v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                    <template v-slot:default>
                        <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.count}}</th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.nom}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.primaryReading}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.conv}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.difference}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.uncertain}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.useTolerance">{{data.block.conf.headers.toleranceError}}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.useTolerance">{{data.block.conf.headers.tolerance}}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.useTolerance">{{data.block.conf.headers.result}}</th>
                            </tr>
                        </thead>
                        <tr v-for="(item, index) in measures.items_up" :key="index">
                            <td class="table-blocks d-flex align-center">
                                <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                <div v-else class="d-flex mr-6"></div>
                                <div class="d-flex justify-center flex-shrink-0 flex-grow-1 pr-1">{{index + 1}}</div>
                            </td>
                            <td class="table-blocks">
                                <NumericField dense outlined
                                    @input="debouncedNom(item)"
                                    placeholder="0"
                                    solo hide-details
                                    :readonly="preview"
                                    :negative="true"
                                    v-model="item.nom" 
                                    :precision="currentPrecision" 
                                    :class="readingWarning(item.nom)"/>
                            </td>
                            <td class="table-blocks">
                                <NumericField dense outlined
                                    @input="debouncedInterpolate(item, 'up')" 
                                    placeholder="0" 
                                    solo hide-details 
                                    :readonly="preview" 
                                    v-model="item.primaryReading" 
                                    :negative="true"/>
                            </td>
                            <td class="table-blocks">
                                <NumericField dense outlined
                                    hide-details 
                                    disabled
                                    :negative="true"
                                    v-model="item.conv"/>
                            </td>
                            <td class="table-blocks">
                                <NumericField dense outlined
                                    @input="calculateDiff(item)" 
                                    placeholder="0" 
                                    :readonly="preview" 
                                    solo hide-details 
                                    v-model="item.reading" 
                                    :precision="currentPrecision"
                                    :negative="true"
                                    :class="readingWarning(item.reading)"/>
                            </td>
                            <td class="table-text-blocks text-right">
                                <b>{{item.difference | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks  text-right">
                                <b>{{item.uncertain | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right" v-if="measures.useTolerance">
                                <b>{{item.toleranceError | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right" v-if="measures.useTolerance">
                                <b>{{item.tolerance | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right" v-if="measures.useTolerance">
                                <StatusIcon 
                                    :status="item.result"
                                    :tooltip_text="row_tooltip[item.result]" />
                            </td>
                        </tr>
                    </template>
                </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                    <template v-slot:default>
                        <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right" >{{data.block.conf.headers.count}}</th>
                                <th class="table-text-blocks text-right" >{{data.block.conf.headers.nom}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" >{{data.block.conf.headers.primaryReading}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" >{{data.block.conf.headers.conv}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" >{{data.block.conf.headers.reading}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" >{{data.block.conf.headers.difference}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" >{{data.block.conf.headers.uncertain}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.useTolerance">{{data.block.conf.headers.toleranceError}}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.useTolerance">{{data.block.conf.headers.tolerance}}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.useTolerance">{{data.block.conf.headers.result}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measures.items_down" :key="index">
                                <td class="table-blocks d-flex align-center">
                                    <div class="d-flex mr-6"></div>
                                    <div class="d-flex justify-center flex-shrink-0 flex-grow-1 pr-1">{{index + 1}}</div>
                                </td>
                                <td class="table-blocks">
                                    <NumericField dense outlined
                                        @input="debouncedNom(item)" 
                                        placeholder="0" 
                                        solo hide-details 
                                        :readonly="preview" 
                                        v-model="item.nom" 
                                        :precision="currentPrecision"
                                        :class="readingWarning(item.nom)"
                                        :negative="true"/>
                                </td>
                                <td class="table-blocks">
                                    <NumericField dense outlined
                                        @input="debouncedInterpolate(item, 'up')" 
                                        placeholder="0" 
                                        solo hide-details 
                                        :readonly="preview" 
                                        v-model="item.primaryReading"
                                        :negative="true"/>
                                </td>
                                <td class="table-blocks">
                                    <NumericField dense outlined
                                        solo hide-details
                                        disabled
                                        :negative="true"
                                        v-model="item.conv"/>
                                </td>
                                <td class="table-blocks">
                                    <NumericField dense outlined
                                        @input="calculateDiff(item)"
                                        placeholder="0"
                                        :readonly="preview"
                                        solo hide-details
                                        v-model="item.reading"
                                        :precision="currentPrecision"
                                        :class="readingWarning(item.reading)"
                                        :negative="true"/>
                                </td>
                                <td class="table-blocks text-right">
                                    <b>{{item.difference | formatNumber}}</b>
                                </td>
                                <td class="table-blocks text-right">
                                    <b>{{item.uncertain | formatNumber}}</b>
                                </td>
                                <td class="table-blocks text-right" v-if="measures.useTolerance">
                                    <b>{{item.toleranceError | formatNumber}}</b>
                                </td>
                                <td class="table-blocks text-right" v-if="measures.useTolerance">
                                    <b>{{item.tolerance | formatNumber}}</b>
                                </td>
                                <td class="table-blocks text-right pr-2" v-if="measures.useTolerance">
                                    <StatusIcon 
                                        :status="item.result" 
                                        :tooltip_text="row_tooltip[item.result]" />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div class="d-flex justify-end my-2">
                        <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow()"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                    </div>
                </div>
            </v-row>
        </v-container>
    </div>
    </LayoutBlock>
</template>
<script>
import { pressuregauge_scie } from '../../../utils/itemBlockSchema'
import {BaseIso} from "../../../utils/baseIso"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {handleInterpolation, calculateUncertainty} from "../../../utils/report_utility"
import Big from "big.js"
// // import _ from 'lodash'

export default {
    components: {LayoutBlock, StatusIcon},
    mixins: [BaseIso],
    created() {
        this.debouncedInterpolate = _.debounce(function(item, direction){
            // console.log('debouncedInterpolate')
            this.interpolateValue(item, direction)
        },1000)

        this.debouncedNom = _.debounce(function(item){
            this.changeNom(item)
        })
    },
    methods: {
        async buildMeasures(){
            this.measures = {
                items_up: [],
                items_down: [],
                tolerance: null,
                k: 2,
                useTolerance: true,
                result: 'uncomplete'
            }
            this.buildTolerances()
            if(this.measures.tolerance == null){
                this.measures.useTolerance = false
            }
            let valuesFromCategory = await this.buildWithCategory()
            if(valuesFromCategory){
                for (let i = 0; i< this.data.block.conf.min_readings; i++){
                    this.addRow(valuesFromCategory[i])
                } 
            } else {
                for (let i = 0; i< this.data.block.conf.min_readings; i++){
                    this.addRow()
                }
            }
           
        },
        calcBlockResult() {
            // console.log('CALC BLOCK RESULT')
            let result_up = 'done'
            result_up = this.measures.items_up.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let result_down = 'done'
            result_down = this.measures.items_down.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            // console.log('CALC BLOCK RESULT', result_up, result_down)
            if (result_up == result_down) {
                this.measures.result = result_up
            } else if (result_up == 'uncomplete' || result_down == 'uncomplete') {
                this.measures.result = 'uncomplete'
            } else if (result_up == 'failed' || result_down == 'failed') {
                this.measures.result = 'failed'
            }
            // console.log('CALC BLOCK RESULT', result_up, result_down, this.measures.result)
        },
        autoFillPressureGauge(measures){
            this.autoFillWrapper(measures.items_up)
            this.autoFillWrapper(measures.items_down)
        },
        addRow(nom_value = null){
            let item = pressuregauge_scie({
                nom: nom_value,
                index: this.measures.items_up.length,
                tolerance: this.measures.tolerance
            })
            let item_down  = pressuregauge_scie({
                nom: nom_value,
                index: this.measures.items_up.length,
                tolerance: this.measures.tolerance
            })
            this.measures.items_up.push(item)
            this.measures.items_down.unshift(item_down)
        },
        changeNom(item){
            let row_down = this.findRow(this.measures.items_down, item.index)
            row_down.nom = item.nom
            this.interpolateValue(item, 'up')
            this.interpolateValue(row_down, 'down')
        },
        interpolateValue(item, direction){
            if(item.nom != null && item.nom != "" && item.primaryReading != null && item.primaryReading != ""){
                if(!this.checkPrimaryExists(this.currentPrimary)){
                    this.currentPrimary = this.findPrimaryByFamily(["manometro campione"])
                }
                if(this.currentPrimary){
                    let primaryData = this.data.primaries[0].primary_data.data
                    let dataToInterpolate = {}
                    if(direction == 'down'){
                        dataToInterpolate.uniformity = primaryData.uniformity
                        dataToInterpolate.drift = primaryData.drift
                        dataToInterpolate.a = primaryData.a_down
                        dataToInterpolate.b = primaryData.b_down
                        dataToInterpolate.c = primaryData.c_down
                        dataToInterpolate.d = primaryData.d_down
                        dataToInterpolate.a_U = primaryData.a_U_down
                        dataToInterpolate.b_U = primaryData.b_U_down
                    } else {
                        dataToInterpolate = primaryData
                    }
                    let result = handleInterpolation(parseFloat(item.nom), dataToInterpolate)
                    // console.log("$$ debug result", direction, result)
                    if(result != null){
                        item.conv = this.round(Big(item.primaryReading).minus(result.error))
                        item.uncertain = this.round(this.calculateUncertainFull(item.primaryReading, result.uncertain, primaryData, this.measures.k), this.precision*2) 
                    }
                }
            }
        },
        calculateUncertainFull(value, interpolated_U, primaryData, k){
            let range = this.calcMinRange(value)
            return calculateUncertainty(interpolated_U, primaryData, Big(range.d).times(2).toString(), k)
        },
        findRow(items, index){
            return items.find(function(a){
                return a.index == index
            })
        },
        handleInvalidPrimaries(){
            if(this.data.primaries && this.data.invalidPrimaries){
                // console.log("$$ using method from baseIso")
                this.measures.items_up.forEach(item => {
                    item.conv = 0
                    item.primaryReading = 0
                    item.uncertain = 0
                    item.difference = this.round(Big(0).minus(item.reading))
                })
                this.measures.items_down.forEach(item => {
                    item.conv = 0
                    item.primaryReading = 0
                    item.uncertain = 0
                    item.difference = this.round(Big(0).minus(item.reading))
                })
            }
        },
        handleToleranceChange(){
            for(let item of this.measures.items_up){
                item.toleranceError = this.handleToleranceError(item)
                item.tolerance = this.measures.tolerance
            }
            for (let item of this.measures.items_down){
                item.toleranceError = this.handleToleranceError(item)
                item.tolerance = this.measures.tolerance
            }
        },
        removeRow(index){
            // console.log("$$ remove row", index, this.measures.items_down.length - index - 1, this.measures.items_down)
            let item = this.measures.items_up.splice(index,1)
            this.measures.items_down.splice(this.measures.items_down.length - index - 1,1)
            console.log(item)
        }

    },
    computed: {
        precision_overflow() {
            for (let elm of this.measures.items_up) {
                let res = this.checkReading(elm.reading)
                switch (res) {
                    case 'uncomplete':
                    case 'done':
                        break
                    case 'failed':
                        return true
                }
            }
            
            for (let elm of this.measures.items_down) {
                let res = this.checkReading(elm.reading)
                switch (res) {
                    case 'uncomplete':
                    case 'done':
                        break
                    case 'failed':
                        return true
                }
            }
            return false
        },
        
    }
}
</script>